import { createFileRoute } from "@tanstack/react-router";
import AboutUsPage from "@/pages/AboutUsPage";
import { buildHead, SITE_URL, ORG_ID } from "@/lib/seo-head";

export const Route = createFileRoute("/about-us")({
  head: () =>
    buildHead({
      title: "About Abacus | Interior Fit-Out & Joinery Experts in Bahrain",
      description:
        "Abacus is a Bahrain-based interior fit-out, joinery and lighting company with 24+ years crafting luxury commercial, hospitality and retail interiors across the GCC.",
      path: "/about-us",
      schemaJson: {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "About Abacus Design Solutions",
        url: `${SITE_URL}/about-us`,
        mainEntity: { "@id": ORG_ID },
        about: { "@id": ORG_ID },
      },
    }),
  component: AboutUsPage,
});
